import React, { useContext, useEffect, useState } from 'react'
import moment from 'moment';
import 'moment-timezone';
import 'moment-duration-format';
import { AuthContext } from '../../store/auth-context'
import styles from './Comments.module.css'
import { removeHtmlTags } from '../Common/Common';


const SectionalComments = ({sectionalComments, commentsFilter}: any) => {

    const authCtx = useContext(AuthContext)

    const [comments, setComments] = useState([])

    useEffect(() => {
        setComments(sectionalComments)
    }, [sectionalComments])

    useEffect(() => {
        if(commentsFilter) {
            let comments = sectionalComments.filter((comment: any) => comment.is_current_user)
            setComments(comments)
        } else {
            setComments(sectionalComments)
        }
    }, [commentsFilter])

    const sectionalCommentsUI = comments && comments.length > 0 && comments.map(({section_title, comment, question_id, feedback_by}: any, index: number) => {
        comment = removeHtmlTags(comment)
        return  comment && <li key={`comment-${question_id}-${index}`} className="list-unstyled mt-4">
                    <div className="d-flex">
                        <span className={`rounded-circle ${styles.profileIcon}`}>
                            <i className="bi bi-chat-dots fs-6"></i>
                        </span>
                        <div>
                            <div className='d-flex'>
                                <span className={styles.user}>{feedback_by}</span>
                                <span className={`${styles.commentedOn}`}>&nbsp;on {moment.tz(comment.date, "UTC").format('MMMM D, YYYY z')}</span>
                            </div>
                            <div className={`${styles.sectionTitle} mt-1`}>{section_title}</div>
                        </div>
                    </div>
                    <div className={`${styles.commentText} mt-2`}>
                        { comment }
                    </div>
                </li>
    })

    return (
        <div>
            { sectionalCommentsUI }
        </div>
    )
}

export default SectionalComments
